import React, { useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import axiosInstance, {
    clearAuthData,
    isJwtAuthFailure,
} from "../../components/content/axiosConfig";
import Preloader from "../../components/custom/preLoader";
import showErrorToast, { showSuccessToast } from "../../components/toast/toast";

const UpdatePassword = () => {
    const history = useHistory();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);

    const [formData, setFormData] = useState({
        password: "",
        confirmPassword: "",
    });

    const handleChange = (e) => {
        const { id: fieldId, value, type, checked, name } = e.target;
        if (type === "radio") {
            setFormData({
                ...formData,
                [name]: value === "true",
            });
        } else {
            setFormData({
                ...formData,
                [fieldId]: type === "checkbox" ? checked : value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setIsLoading(true);
            if (formData.password === formData.confirmPassword) {
                if (formData.password.length >= 8) {
                    await axiosInstance.post(
                        `api/User/UpdatePassword`,
                        {
                            password: formData.password,
                            confirmPassword: formData.confirmPassword,
                        },
                        {
                            params: { id: id },
                        }
                    );
                    showSuccessToast("Password updated successfully");
                    history.goBack();
                } else {
                    setIsLoading(false);
                    showErrorToast("Password should be at least eight characters long.");
                }
            } else {
                setIsLoading(false);
                showErrorToast("Passwords do not match.");
            }
        } catch (error) {
            setIsLoading(false);
            if (isJwtAuthFailure(error)) {
                clearAuthData();
                window.location.href = "/user/login";
                return;
            }
            const errorMessage = error.response?.data?.message || "An error occurred.";
            showErrorToast(errorMessage);
            console.error("Error updating password:", error);
        }
    };

    return (
        isLoading ? <Preloader /> :
        <div>
            <form onSubmit={handleSubmit} className="fs-13px">
                <div className="d-flex align-items-center mb-3">
                    <div>
                        <ul className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/">Home</Link>
                            </li>
                            <li className="breadcrumb-item">
                                <Link to="/staff">Staff</Link>
                            </li>
                            <li className="breadcrumb-item active">
                            </li>
                        </ul>
                        <h1 className="page-header mb-0">Change Password</h1>
                    </div>
                    <div className="ms-auto">
                        <button
                            type="submit"
                            className="btn btn-success btn-rounded px-4 rounded-pill"
                        >
                            <i className="fa fa-plus fa-lg me-2 ms-n2 text-success-900"></i>
                            Submit
                        </button>
                    </div>
                </div>
                <div className="card border-0">
                    <ul className="nav nav-tabs nav-tabs-v2 px-3">
                        <li className="nav-item me-2">
                            <Link to={"/UpdateStaff/" + id} className="nav-link px-2">General</Link>
                        </li>
                        <li className="nav-item me-2">
                            <Link className="nav-link px-2 active">
                                Password
                            </Link>
                        </li>
                    </ul>
                    <div className="tab-content p-3">
                        <div className="tab-pane fade show active" id="allTab">
                            <div className="form-floating mb-15px">
                                <input
                                    type="password"
                                    className="form-control h-45px fs-13px"
                                    placeholder="Password"
                                    id="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                />
                                <label
                                    htmlFor="password"
                                    className="d-flex align-items-center fs-13px text-gray-600"
                                >
                                    Password
                                </label>
                            </div>

                            <div className="form-floating mb-15px">
                                <input
                                    type="password"
                                    className="form-control h-45px fs-13px"
                                    placeholder="Confirm Password"
                                    id="confirmPassword"
                                    value={formData.confirmPassword}
                                    onChange={handleChange}
                                />
                                <label
                                    htmlFor="confirmPassword"
                                    className="d-flex align-items-center fs-13px text-gray-600"
                                >
                                    Confirm Password
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default UpdatePassword;